import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { TextField } from "@mui/material";
import "./Modal.css";
import Loader from "../Components/Loader";
import { getAllAccount } from "../Store/Actions/TicketAction";

const Modal = ({
  confirmEndChat,
  onClose,
  optionEndChat,
  igTicketEndchat,
  caseid,
  assignmentid,
  handleEndChat,
  isEndingChat,
  setIsCreateTicketDialogShown,
  chatSource,
}) => {
  const [closingMessage, setClosingMessage] = useState("");
  const [haveClosingMessage, setHaveClosingMessage] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { myInfo } = useSelector((state) => state.auth);

  useEffect(() => {
    getAllAccount(myInfo.user.AgentID)
      .then((response) => {
        if (response.status) {
          if (
            chatSource === "FBCHAT" &&
            response.data.facebook[0]?.ClosingMessage
          ) {
            setClosingMessage(response.data.facebook[0]?.ClosingMessage);
            setHaveClosingMessage(true);
          } else if (
            chatSource === "IG" &&
            response.data.instagram[0]?.ClosingMessage
          ) {
            setClosingMessage(response.data.instagram[0]?.ClosingMessage);
            setHaveClosingMessage(true);
          } else if (
            chatSource === "WABA" &&
            response.data.waba[0]?.ClosingMessage
          ) {
            setClosingMessage(response.data.waba[0]?.ClosingMessage);
            setHaveClosingMessage(true);
          }

          setIsLoading(false);
        } else {
          console.log("error", response.error);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsLoading(false);
      });
  }, []);

  const handleCreateTicket = () => {
    setIsCreateTicketDialogShown(true);
    onClose();
  };

  return (
    <div className="overlay">
      <div
        onClick={(e) => e.stopPropagation()}
        className="modalContainer end-chat"
      >
        <div className="modalRight">
          <CloseOutlinedIcon className="closeBtn" onClick={onClose} />

          <div className="content">
            <h1>Caution!</h1>

            {isLoading ? (
              <Loader />
            ) : (
              <>
                {optionEndChat === "addTicket" ? (
                  <p>You are about to end this chat and create a new ticket</p>
                ) : (
                  <p>You are about to end this chat</p>
                )}

                {haveClosingMessage && (
                  <>
                    <h4>Send closing message</h4>

                    <div className="message-input-container">
                      <TextField
                        className="message-input"
                        InputLabelProps={{ shrink: false }}
                        minRows={3}
                        multiline
                        value={closingMessage}
                        onChange={(e) => setClosingMessage(e.target.value)}
                      />
                    </div>
                  </>
                )}
              </>
            )}
          </div>

          <div className="btnContainer">
            <button className="btn_Cancel" onClick={onClose}>
              Cancel
            </button>

            <button
              className="btn_Confirm"
              disabled={isEndingChat}
              onClick={() => {
                if (chatSource === "WA") {
                  confirmEndChat(
                    optionEndChat === "endChat" ? 0 : 1,
                    caseid,
                    assignmentid
                  );
                } else {
                  if (optionEndChat === "addTicket") {
                    handleCreateTicket();
                  } else {
                    handleEndChat(undefined, closingMessage);
                  }
                }
              }}
            >
              {isEndingChat && <Icon height="24" icon="eos-icons:loading" />}
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
